import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "@/providers/contexts";
import { LoadingState } from "@/components/views";

export const SocialLoginRedirect = () => {
  const navigate = useNavigate();
  const { dispatch, refetchUser } = useUserContext();

  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    const params = new URLSearchParams(window.location.search);
    const access = params.get("access");
    const refresh = params.get("refresh");
    const userId = params.get("userId");

    if (access && refresh && userId) {
      localStorage.setItem("authToken", access);
      localStorage.setItem("refreshToken", refresh);
      localStorage.setItem("userId", userId);

      dispatch({ type: "SET_USER_ID", payload: parseInt(userId) });
      dispatch({ type: "SET_AUTHTOKEN", payload: access });

      refetchUser().then(() => {
        navigate("/", { replace: true });
      });
    } else {
      navigate("/login", { replace: true });
    }
  }, [dispatch, refetchUser, navigate]);

  return <LoadingState message="Logging you in..." />;
};
